export { default as NScrollbar, scrollbarProps } from './src/Scrollbar';
